<template>
  <base-container>
    <avue-crud
      ref="crud"
      :data="data"
      :table-loading="loading"
      :option="option"
      :page.sync="page"
      @search-change="searchChange"
      @search-reset="searchReset"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshChange"
      @on-load="onLoad"
    >
      <template slot="menu" slot-scope="scope">
        <el-button
          v-if="scope.row.checkStatus == 2"
          :key="scope.index"
          type="text"
          size="small"
          plain
          class="none-border"
          @click.stop="handlePass(scope.row, scope.index)"
        >去审核
        </el-button>
        <el-button
          v-else
          icon="el-icon-view"
          type="text"
          size="small"
          plain
          class="none-border"
          @click.stop="handleView(scope.row, scope.index)"
        >查看
        </el-button>
      </template>
      <template slot="checkStatus" slot-scope="{ row }">
        <el-tag>{{ findCheckStatusTagName(row) }}</el-tag>
      </template>
    </avue-crud>
  </base-container>
</template>

<script>
const PAGE_DETAIL_ROUTER = '/user/video/detail'
import { checkStatusEnum, LOCAL_STORAGE_KEY_AUTH_VIDEO_ITEM } from './const'
import { getVideoCheckList } from '@/api/user'
import { find } from 'ramda'
export default {
  name: 'VideoList',
  data() {
    return {
      form: {},
      data: [],
      query: {},
      loading: false,
      page: {
        pageSize: 20,
        currentPage: 1,
        total: 0
      },
      option: {
        addBtn: false,
        editBtn: false,
        delBtn: false,
        searchShow: true,
        columnBtn: false,
        searchBtnText: '查询',
        emptyBtnText: '重置',
        stripe: true,
        searchMenuSpan: 7,
        calcHeight: 350,
        tip: false,
        border: true,
        index: true,
        menuWidth: 100,
        searchSpan: 9,
        menu: true,
        column: [
          {
            label: '昵称',
            prop: 'nickname',
            search: true
          },
          {
            label: '手机号码',
            prop: 'mobile',
            search: true
          },
          {
            label: '邮箱',
            prop: 'email'
          },
          {
            label: '审核状态',
            search: true,
            type: 'select',
            searchValue: ' ',
            slot: true,
            dicData: checkStatusEnum,
            prop: 'checkStatus'
          },

          {
            label: '申请时间',
            prop: 'applyTime',
            sortable: true,
            width: 150
          }
        ]
      }
    }
  },
  methods: {
    findCheckStatusTagName(row) {
      return find((item) => item.value === row.checkStatus)(checkStatusEnum).label
    },
    searchReset() {
      this.query = {}
      this.onLoad(this.page)
    },
    searchChange(params, done) {
      this.query = params
      this.page.currentPage = 1
      this.onLoad(this.page, params)
      done()
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize
    },
    refreshChange() {
      this.onLoad(this.page, this.query)
    },
    onLoad(page, params = {}) {
      this.loading = true
      getVideoCheckList(page.currentPage, page.pageSize, params)
        .then((res) => {
          this.page.total = res.total
          this.data = res.data
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    handleView(row) {
      const { id } = row
      window.localStorage.setItem(
        LOCAL_STORAGE_KEY_AUTH_VIDEO_ITEM,
        JSON.stringify(row)
      )
      this.$router.push({ path: PAGE_DETAIL_ROUTER, query: { id }})
    },
    handlePass(row) {
      const { id } = row
      window.localStorage.setItem(
        LOCAL_STORAGE_KEY_AUTH_VIDEO_ITEM,
        JSON.stringify(row)
      )
      this.$router.push({ path: PAGE_DETAIL_ROUTER, query: { id }})
    }
  }
}
</script>

<style>
.none-border {
  border: 0;
  background-color: transparent !important;
}
</style>
